module.exports = __webpack_public_path__ + "static/Poppins-Regular-0d58cc45d38dee5a744d557230381a5a.woff2";